import * as React from "react";
import Modal from "@mui/material/Modal";

import classes from "./ContactModal.module.css";
import AuthContext from "../../../auth-context";
import AddConatct from "./AddContact";

const ContactModal = (props) => {
  const { lable, handleClose } = props;
  const authCtx = React.useContext(AuthContext);
  // console.log(client_name);
  return (
    <div>
      <Modal
        open={authCtx.opencontactModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={classes.maincontainer}>
          <div className={classes.mainheader}>
            <p className={classes.mainhead}>Contac Us</p>
            <p>{lable}</p>
          </div>
          <div className={classes.storecontainer}>
            <AddConatct onClose={props.handleClose}/>
          </div>

          <div className={classes.btns_mini}>
            <button className={classes.btnsave} onClick={props.handleClose}>
              Save
            </button>
            <button className={classes.btncancel} onClick={props.handleClose}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ContactModal;
